export default "../css/fa3d72c8f5bdc7b0e2f8c6ce12a52496.ttf";